import { Link } from "react-router-dom";
import { BrandMark } from "@anyseal/ui";
import { useI18n } from "../i18n";

const footerLinks = {
  "zh-CN": {
    tagline: "统一接入全球顶尖大模型。",
    cols: [
      {
        title: "产品",
        items: [
          { label: "模型列表", to: "/models" },
          { label: "企业方案", to: "/enterprise" },
          { label: "开发文档", to: "/dashboard/docs" },
          { label: "控制台",   to: "/dashboard" },
        ],
      },
      {
        title: "公司",
        items: [
          { label: "服务条款", to: "/legal/public" },
          { label: "隐私政策", to: "/legal/public" },
        ],
      },
      {
        title: "开发者",
        items: [
          { label: "快速开始",   to: "/dashboard/docs" },
          { label: "模型列表",   to: "/models" },
        ],
      },
    ],
    copy: `© ${new Date().getFullYear()} LonMax AI`,
    trademark:
      "模型厂商名称与标识用于说明其各自模型的来源，商标归相应所有者。",
  },
  en: {
    tagline: "Unified access to the world's leading AI models.",
    cols: [
      {
        title: "Product",
        items: [
          { label: "Models",     to: "/models" },
          { label: "Enterprise", to: "/enterprise" },
          { label: "Docs",       to: "/dashboard/docs" },
          { label: "Dashboard",  to: "/dashboard" },
        ],
      },
      {
        title: "Company",
        items: [
          { label: "Terms of service",  to: "/legal/public" },
          { label: "Privacy policy",    to: "/legal/public" },
        ],
      },
      {
        title: "Developer",
        items: [
          { label: "Quickstart",    to: "/dashboard/docs" },
          { label: "Models",        to: "/models" },
        ],
      },
    ],
    copy: `© ${new Date().getFullYear()} LonMax AI`,
    trademark:
      "Vendor names and marks identify the origin of their respective models; trademarks belong to their owners.",
  },
} as const;

export function MarketingFooter() {
  const { locale } = useI18n();
  const f = footerLinks[locale];

  return (
    <footer className="mk-footer">
      <div className="mk-footer__inner">
        <div className="mk-footer__top">
          <div className="mk-footer__brand">
            <Link
              className="mk-nav__brand"
              to="/"
              aria-label="LonMax AI"
            >
              <BrandMark size={26} />
              <span>LonMax AI</span>
            </Link>
            <p className="mk-footer__tagline">{f.tagline}</p>
          </div>
          <div className="mk-footer__cols">
            {f.cols.map((col) => (
              <div key={col.title} className="mk-footer__col">
                <h4>{col.title}</h4>
                <ul>
                  {col.items.map((item) => (
                    <li key={item.label}>
                      <Link to={item.to}>{item.label}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="mk-footer__bottom">
          <p>{f.copy}</p>
          <p>{f.trademark}</p>
        </div>
      </div>
    </footer>
  );
}
